import { useTranslation } from "react-i18next";
import Layout from 'Components/Layout';
import { getSentInvitations, sendInvitation } from 'Modules/API';
import React, { useState } from 'react'; // Simple copy to clipboard function using native API

const copyToClipboard = text => {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  } else {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    } finally {
      document.body.removeChild(textArea);
    }
  }
};

export default function SendInvite() {
  const {
    t
  } = useTranslation();
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  const [sent, setSent] = useState([]);

  const onSubmit = async e => {
    e.preventDefault();
    setError('');
    setResult(null);
    setLoading(true);

    try {
      const res = await sendInvitation({
        email: email.trim(),
        subject: subject.trim(),
        message: message.trim()
      });
      const payload = res && res.data ? res.data : res;
      setResult(payload); // refresh sent list

      try {
        const sentRes = await getSentInvitations();
        const list = sentRes && sentRes.data ? sentRes.data : [];
        if (Array.isArray(list)) setSent(list);
      } catch (_) {}
    } catch (err) {
      setError('Failed to send invitation');
    } finally {
      setLoading(false);
    }
  };

  return <Layout>
      <div className='container' style={{
      paddingTop: 24,
      paddingBottom: 24,
      maxWidth: 720
    }}>
        <h2>{t("Send Invitation")}</h2>
        <p>{t("Send an invitation by email. You must be logged in.")}</p>
        <form onSubmit={onSubmit}>
          <div className='form-group'>
            <label htmlFor='inviteEmail'>{t("Recipient Email")}</label>
            <input id='inviteEmail' className='form-control' type='email' value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className='form-group'>
            <label htmlFor='inviteSubject'>{t("Subject")}</label>
            <input id='inviteSubject' className='form-control' type='text' value={subject} onChange={e => setSubject(e.target.value)} placeholder={t("Connection Invitation")} />
          </div>
          <div className='form-group'>
            <label htmlFor='inviteMessage'>{t("Message")}</label>
            <textarea id='inviteMessage' className='form-control' rows={4} value={message} onChange={e => setMessage(e.target.value)} placeholder={`Hi! I'd like to share my contact information with you.`} />
          </div>
          <button className='btn btn-success' type='submit' disabled={loading}>{loading ? 'Sending...' : 'Send Invitation'}</button>
        </form>
        {error && <p className='mt-3 text-danger'>{error}</p>}
        {result && <div className='alert alert-success mt-3'>
            <div>{t("Invitation sent!")}</div>
            {result.invitationUrl && <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          flexWrap: 'wrap'
        }}>
                <span>{t("Share link:")}</span>
                <a href={result.invitationUrl} target='_blank' rel='noopener noreferrer'>{result.invitationUrl}</a>
                <button type='button' className='btn btn-sm btn-outline-secondary' onClick={() => copyToClipboard(result.invitationUrl)}>{t("Copy")}</button>
              </div>}
          </div>}
        {Array.isArray(sent) && sent.length > 0 && <div className='mt-4'>
            <h5>{t("Your Pending Sent Invites")}</h5>
            <ul>
              {sent.slice(0, 5).map(inv => <li key={inv.id}>{inv.email || inv.toUser?.email || inv.phone || 'Unknown'} — {new Date(inv.createdAt).toLocaleString()}</li>)}
            </ul>
          </div>}
      </div>
    </Layout>;
}